import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

const GetHolidays = async (queryParams) => {
  const token = await getAccessToken();
  queryParams = queryParams || {};
  const params = new URLSearchParams();
  let paramCount = 0;
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null && value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => { params.append(key, v); paramCount++; });
      } else {
        params.append(key, value);
        paramCount++;
      }
    }
  });
  let url = `${config.API_URL}/holidays`;
  if (paramCount > 0) url += `?${params.toString()}`;
  const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` };
  try {
    return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) { throw error; }
};

const SearchHolidays = async (queryParams) => {
  const token = await getAccessToken();
  queryParams = queryParams || {};
  const params = new URLSearchParams();
  let paramCount = 0;
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null && value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => { params.append(key, v); paramCount++; });
      } else {
        params.append(key, value);
        paramCount++;
      }
    }
  });
  let url = `${config.API_URL}/holidays/search`;
  if (paramCount > 0) url += `?${params.toString()}`;
  const headers = { "Content-Type": "application/x-www-form-urlencoded", Authorization: `Bearer ${token}` };
  try {
    return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) { throw error; }
};

const GetHolidaysInDates = async (dates = []) => {
  if (!dates.length) return [];
  const years = [...new Set(dates.map((d) => Number(d.split("/")[2])))];
  try {
    const res = await SearchHolidays({ in_years: years, status: 1 });
    if (res?.data?.is_success && Array.isArray(res.data.result)) {
      const holidayDates = res.data.result.map((h) => {
        const d = new Date(h.in_date);
        return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
      });
      return dates.filter((d) => holidayDates.includes(d));
    }
    return [];
  } catch (error) { throw error; }
};

const CreateHoliday = async (req) => {
  const token = await getAccessToken();
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
  try {
    return await apiClient.post(`${config.API_URL}/holidays`, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) { throw error; }
};

const UpdateHoliday = async (id, req) => {
  const token = await getAccessToken();
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
  try {
    return await apiClient.put(`${config.API_URL}/holidays/${id}`, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) { throw error; }
};

const DeleteHoliday = async (id) => {
  const token = await getAccessToken();
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, User: getUserEmail() };
  try {
    return await apiClient.patch(`${config.API_URL}/holidays/${id}`, JSON.stringify({ status: 0 }), { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) { throw error; }
};

const HolidayService = {
  GetHolidays,
  SearchHolidays,
  GetHolidaysInDates,
  CreateHoliday,
  UpdateHoliday,
  DeleteHoliday,
};

export default HolidayService;